namespace RedBullMOBILE360.SalesApp {
    export interface WalletTransferImportForm {
        FileName: Serenity.ImageUploadEditor;
    }

    export class WalletTransferImportForm extends Serenity.PrefixedContext {
        static formKey = 'SalesApp.WalletTransferImport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!WalletTransferImportForm.init)  {
                WalletTransferImportForm.init = true;

                var s = Serenity;
                var w0 = s.ImageUploadEditor;

                Q.initFormType(WalletTransferImportForm, [
                    'FileName', w0
                ]);
            }
        }
    }
}
